import React from 'react';
import PropTypes from 'prop-types';
import Hyperlink from '../../common/Hyperlink';

const Logo = ({ className }) => {
  return (
    <Hyperlink to="/" className={className} aria-label="IDAGIO">
      <svg
        className="logoSvg"
        width="140"
        title="IDAGIO"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 724.41 116.41"
      >
        <path
          fill="white"
          d="M34.95 93.05H76.9v20.97H34.95V93.05zM0 23.14v69.91L55.92 58.1 0 23.14zM153.43 114.02h-20.57V2.39h20.57v111.63zM281.8 58.21C281.8 93 257.4 114 223.75 114H188V2.39h35.72c33.65 0 58.05 21.05 58.05 55.82zm-73.36-37v74h16.27c20.09 0 35.08-12.91 35.08-37s-15-37-35.08-37zM371.76 88.66h-45.93L316.42 114h-22.64L338.59 2.39H359L403.81 114h-22.64l-9.41-25.36zm-6.7-18.49l-16.27-43.7-16.26 43.7zM530.53 57.25c0 31.73-17.86 59.16-55.5 59.16-34.12 0-59-22.48-59-58.2C416 23.76 439.47 0 476 0c18.5 0 32.69 6.22 43.37 14.83l-13.56 17.38a46.94 46.94 0 0 0-30.62-11.32c-22.8 0-36.84 16.11-36.84 37.32 0 21.68 14.52 37.31 37.64 37.31 21.53 0 31.41-13.71 32.69-25.83h-32.05V50.87h53.74c.16 2.23.16 4.31.16 6.38zM578.82 114.02h-20.57V2.39h20.57v111.63zM724.41 58.21c0 34.6-25.35 58.2-58.52 58.2s-58.37-23.6-58.37-58.2S632.72 0 665.89 0s58.52 23.6 58.52 58.21zm-94.56 0c0 22.16 15.15 37.31 36 37.31 21.05 0 36-15.15 36-37.31s-15-37.32-36-37.32c-20.89 0-36 15.15-36 37.32z"
        />
      </svg>
    </Hyperlink>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
};

export default Logo;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/logo/Logo.js